export class DadosAcessoConsumidor {
    public UserName: string; 
    public Password: string;
    public Token: string;   
  }


// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/shared/dados-acesso-consumidor.ts